import { createFileRoute } from "@tanstack/react-router";

import { ErrorPage } from "@/features/misc/routes/Error";

export const Route = createFileRoute("/error")({
  component: ErrorPage,
});
